import { FIELD_PATHS, FREQUENCY_EXPENSE_OPTIONS } from '@funnels/constants';
import { AssetEntityIndex, PropertyExpenseIndex } from '@funnels/types';

import { DropdownField } from '../../Fields';
import { EditableViewProps } from '../types';

interface PropertyExpenseFrequencyTeamViewProps extends EditableViewProps, AssetEntityIndex, PropertyExpenseIndex {}

export function PropertyExpenseFrequencyTeamView(props: PropertyExpenseFrequencyTeamViewProps) {
  const { assetIndex, propertyExpenseIndex } = props;

  return (
    <DropdownField
      name={FIELD_PATHS.ASSET_PROPERTY_EXPENSE_FREQUENCY(assetIndex, propertyExpenseIndex)}
      options={FREQUENCY_EXPENSE_OPTIONS}
      isFullWidth
      isOptional
      shouldAnchorList
    />
  );
}
